import type { WebViewMessage } from "web_myplann/Utils/WebViewModel";

export const isWebViewMessage = (data: unknown): data is WebViewMessage =>
	typeof data === "object" &&
	data !== null &&
	typeof (data as { type?: unknown }).type === "string";
